import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

// Редирект на внешний домен: react-router Navigate внешние URL не понимает
// (трактует их как относительный путь), поэтому уходим через window.location.
export function ExternalRedirect({ to }) {
    useEffect(() => {
        window.location.replace(to)
    }, [to])

    return null
}

// Запускает скачивание файла и уводит на страницу приложений,
// чтобы пользователь не остался на пустом маршруте.
export function FileDownload({ href }) {
    useEffect(() => {
        const link = document.createElement('a')
        link.href = href
        link.download = ''
        document.body.appendChild(link)
        link.click()
        link.remove()
    }, [href])

    return <Navigate to="/apps" replace />
}
